/* eslint semi:0 */
import analyticsActions from '../actions/analyticsActions'
import { getPlatform, getIsNativeApp, PLATFORMS } from '../../utils/ua'
import scrollingEventsProvider from '../../providers/scrollingEventsProvider'
import { getSingleElementByClass, nodes, addWindowEvent } from '../../utils/dom'
import { SCROLL_EVENTS_SELECTORS } from '../../config/preRenderedSelectorsConfig'

const {
  TITLE,
  BODY_START,
  SHARE_BUTTONS_BOTTOM,
  TOP_POSTS,
  // mobile only
  PAGE_END,
} = SCROLL_EVENTS_SELECTORS

const DESKTOP_AND_MOBILE_SCROLL_SELECTORS = [
  TITLE,
  BODY_START,
  SHARE_BUTTONS_BOTTOM,
  PAGE_END,
]

const SCROLL_ANCHORS_BY_PLATFORM = {
  [PLATFORMS.DESKTOP]: DESKTOP_AND_MOBILE_SCROLL_SELECTORS,
  [PLATFORMS.MOBILE_WEB]: [...DESKTOP_AND_MOBILE_SCROLL_SELECTORS, TOP_POSTS],
  [PLATFORMS.NATIVE_APP]: [],
}

function initAnalyticsAnchorScrollEventListener() {
  const header = getSingleElementByClass('header-container')
  const postCoverForEmbedLayout = getSingleElementByClass('post-cover')
  const relativeTopElement = header || postCoverForEmbedLayout
  const anchorsSelectors = SCROLL_ANCHORS_BY_PLATFORM[getPlatform()] || []
  const baseScrollEventConf = {
    triggerPosition: {
      top: 0,
    },
    relativeTopElement,
    fireOnlyOnce: true,
    vm: analyticsActions,
    event: 'scrollAnchorReached',
    previousInViewportFlag: false,
  }
  for (const element of nodes(anchorsSelectors)) {
    const eventConfig = {
      ...baseScrollEventConf,
      payload: {
        anchor: element,
        category: 'scroll',
        action: 'reached',
        label: `.${Array.join(element.classList, '.')}`,
      },
      element,
    }
    const handler = scrollingEventsProvider.register(eventConfig)

    handler() // In case the anchor is already in the viewport, without scrolling
  }
}

if (!getIsNativeApp()) {
  addWindowEvent('load', initAnalyticsAnchorScrollEventListener)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/analyticsScrollEventInitializer.js